import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { IChangePassForm } from '../shared/interfaces/utils.interface';
import { catchError, throwError } from 'rxjs';
import {
  IBankForm,
  IEditMerchantForm,
  IEditProfileForm,
  ILocationForm,
  IUpdateLocationForm,
} from '../shared/interfaces/form.interface';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private apiUrl = environment.apiUrl; // Replace with your actual API URL
  constructor(private http: HttpClient, private route: Router) {}

  changePassword(passwordData: IChangePassForm) {
    return this.http
      .patch<any>(`${this.apiUrl}auth/changePassword`, passwordData)
      .pipe(catchError(this.handleError));
  }
  initMerchant() {
    return this.http
      .get<any>(`${this.apiUrl}backoffice/my-merchant`)
      .pipe(catchError(this.handleError));
  }
  updateMerchant(formData: FormData, id: string) {
    return this.http
      .put<any>(`${this.apiUrl}backoffice/merchant/${id}`, formData)
      .pipe(catchError(this.handleError));
  }
  updateBankAccount(bankInfo: IBankForm, id: string) {
    return this.http
      .patch<any>(`${this.apiUrl}backoffice/merchant/account/${id}`, bankInfo)
      .pipe(catchError(this.handleError));
  }

  updateMyProfile(bodyData: IEditProfileForm) {
    return this.http
      .put<any>(`${this.apiUrl}user/profile`, bodyData)
      .pipe(catchError(this.handleError));
  }

  createLocation(locationInfo: ILocationForm) {
    return this.http
      .post<any>(`${this.apiUrl}backoffice/merchant/location`, locationInfo)
      .pipe(catchError(this.handleError));
  }

  updateLocation(
    locationInfo: IUpdateLocationForm,
    id: string,
    password: string
  ) {
    return this.http
      .patch<any>(`${this.apiUrl}backoffice/merchant/location/${id}`, {
        location: locationInfo.location,
        link: locationInfo.link,
        province: locationInfo.province,
        password: password,
      })
      .pipe(catchError(this.handleError));
  }

  deleteLocation(id: string, password: string) {
    return this.http
      .delete<any>(`${this.apiUrl}backoffice/merchant/location/${id}`, {
        body: {
          password: password,
        },
      })
      .pipe(catchError(this.handleError));
  }

  getLocationList(id: string) {
    return this.http
      .get<any>(`${this.apiUrl}backoffice/merchant/location`)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      console.error('service::error ', error.error);
    }

    return throwError(() => error.error);
  }
}
